import { FormatPage } from "@/components/FormatPage";
import { usePageTitle } from "@/lib/usePageTitle";

export default function ReadingCircle() {
  usePageTitle("Research Circle | Mentheris", "A small circle reading and discussing research on technological change together.");
  return (
    <FormatPage
      testid="reading-circle-page"
      titleTop="Reading / Research"
      titleAccent="Circle."
      description="A small circle working through essential texts on technology, adaptation, and human-centered systems. Slowly, carefully, and together."
      points={[
        { n: "01", title: "One text per month", text: "A single paper or chapter, chosen at the intersection of technological change and human adaptive capacity, read properly rather than quickly." },
        { n: "02", title: "Slow discussion", text: "An open conversation on the text: what it gets right, what it misses, and what it means for practice." },
        { n: "03", title: "Written synthesis", text: "Each cycle closes with a short written synthesis, shared with the circle and feeding the wider research observatory." },
      ]}
      cta="The circle is forming now. If slow, serious reading sounds like your kind of room, write to us."
    />
  );
}
